export const ADD_INSTANCE_DATA_SUCCESS = 'ADD_INSTANCE_DATA_SUCCESS'
export const ADD_INSTANCE_DATA_FAILURE = 'ADD_INSTANCE_DATA_FAILURE'

export const FETCH_ESG_RESULTS_SUCCESS = 'FETCH_ESG_RESULTS_SUCCESS'
export const FETCH_ESG_RESULTS_FAILURE = 'FETCH_ESG_RESULTS_FAILURE'